;$(function () {
	if(!document.getElementById('graph')) {
		return;
	}

	const canvasEl = document.getElementById('graph');

	if (canvasEl.tagName !== 'CANVAS') {
		return;
	}

	const ctx = document.getElementById('graph').getContext('2d');

	const gradientStroke = ctx.createLinearGradient(0, 0, 0, 200)
	gradientStroke.addColorStop(0, '#FF0033')
	gradientStroke.addColorStop(1, '#3366CC')


	var chart = new Chart(ctx, {
		// The type of chart we want to create
		type: 'line',

		// The data for our dataset
		data: {
			labels: ['Сен 18', 'ОКт 18', 'Ноя 18', 'Дек 18', 'Янв 19', 'Фев 19', 'Март 19', 'Апр 19', 'Май 19', 'Сен 18', 'ОКт 18', 'Ноя 18', 'Дек 18', 'Янв 19', 'Фев 19', 'Март 19', 'Апр 19', 'Май 19'],
			datasets: [{
				fill: false,
				data: [0, 1, 2, 4, 20, 4, 45, 10, 9, 0, 1, 2, 4, 20, 4, 45, 10, 9],
				borderWidth: 2,
				lineTension: 0,
        pointHitRadius: 10,
				borderColor: gradientStroke,
				pointBorderColor: '#ffffff',
				pointBackgroundColor: '#ffffff',
				pointHoverBackgroundColor: '#FF0033',
				pointHoverBorderColor: '#FF0033'
			}]
		},
		responsive: true,
		// Configuration options go here
		options: {
			tooltips: {
				// Disable the on-canvas tooltip
				enabled: false,
				custom: customTooltips
			},
			legend: {
				display: false,
				align: 'start',
				titleAlign: 'center',
				bodyAlign: 'center'
			},
			layout: {
				padding: {
					left: 0,
					right: 0,
					top: 16,
					bottom: 10
				}
			},
			maintainAspectRatio: false,
			aspectRatio: 200 / 1400,
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true,
						display: false
					},
				}],
				xAxes: [{
					ticks: {
						fontColor: '#ffffff',
						fontSize: 14,
					}
				}]
			}
		},

	});


	function customTooltips(tooltip) {
		// Tooltip Element
		var tooltipEl = document.getElementById('chartjs-tooltip');

		if (!tooltipEl) {
			tooltipEl = document.createElement('div');
			tooltipEl.id = 'chartjs-tooltip';
			this._chart.canvas.parentNode.appendChild(tooltipEl);
		}

		// Hide if no tooltip
		if (tooltip.opacity === 0) {
			tooltipEl.style.opacity = 0;
			return;
		}

		// Set caret Position
		tooltipEl.classList.remove('above', 'below', 'no-transform');
		if (tooltip.yAlign) {
			tooltipEl.classList.add(tooltip.yAlign);
		} else {
			tooltipEl.classList.add('no-transform');
		}

		function getBody(bodyItem) {
			return bodyItem.lines;
		}

		// Set Text
		if (tooltip.body) {
			var bodyLines = tooltip.body.map(getBody);

			var innerHtml = '';

			bodyLines.forEach(function (body, i) {
				innerHtml +=  body ;
			});

			tooltipEl.innerHTML = innerHtml;
		}

		var positionY = this._chart.canvas.offsetTop;
		var positionX = this._chart.canvas.offsetLeft;

		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = positionX + tooltip.caretX + 'px';
		tooltipEl.style.top = positionY + tooltip.caretY + 'px';
	}
});
